import { useTranslations } from 'next-intl';
import styles from './SearchControls.module.scss';

interface SearchControlsProps {
  children: React.ReactNode;
}

export const SearchControls: React.FC<SearchControlsProps> = ({ children }) => {
  const t = useTranslations('pages.search.controls');

  return (
    <section className={styles.wrapper} aria-label={t('ariaLabel')}>
      {children}
    </section>
  );
};
